import React, { ReactElement } from 'react';
import styled from 'styled-components';

import { Typography, Flex, Box, ConditionalLink } from 'components';
import { ModuleCardState } from 'features/modules/types';
import { useParams } from 'react-router-dom';
import { createMarkup, createUrl, formatDate } from 'app/utils';

const Square = styled('i')`
  display: block;
  width: 14px;
  height: 14px;
  background: ${({ theme }) => theme.colors.primary_contrast};
  position: relative;
  margin-top: 66px;

  &::after {
    content: '';
    width: 1px;
    height: 80px;
    background: ${({ theme }) => theme.colors.primary_contrast};
    position: absolute;
    bottom: 0;
  }
`;

const ModulesCardWrapper = styled(ConditionalLink)`
  display: flex;
  flex-grow: 1;
  width: 280px;
  height: 330px;
  margin-top: 30px;
  border-radius: 4px;
  flex-direction: column;
  justify-content: flex-start;

  ${(props: any) => {
    if (props['data-isavailable']) {
      if (props['data-isrequired']) {
        return `
          background: ${props.theme.colors.primary_400};
          background: linear-gradient(180deg, ${props.theme.colors.primary_400} 0%, ${props.theme.colors.primary_600} 50%);
        `;
      } else {
        return `
          background: ${props.theme.colors.secondary_400};
          background: linear-gradient(180deg, ${props.theme.colors.secondary_400} 0%, ${props.theme.colors.secondary_600} 50%);
        `;
      }
    } else {
      return `
          background: ${props.theme.colors.dark_350};
        `;
    }
  }}
`;

interface ModulesCardProps {
  productModule: ModuleCardState;
  productClassUuid: string;
}

const ModulesCard = ({ productModule, productClassUuid }: ModulesCardProps): ReactElement => {
  const { productSlug } = useParams();

  let moduleUuid: string | null = productModule.uuid;
  let releaseLabel = '';

  if (!moduleUuid) {
    if (productModule.released) {
      releaseLabel = 'Disponível para alunos';
    } else {
      if (productModule.releaseDate) {
        // releaseLabel = `Disponível em:<br />${formatDate(productModule.releaseDate).format(
        //   'DD/MM/YYYY [às] HH[h]mm [(BRT)]'
        // )}`;

        if (productModule.showDate) {
          releaseLabel = `Disponível em: ${formatDate(productModule.releaseDate).format('DD/MM/YYYY [às] HH[h]mm')}`;
        } else {
          releaseLabel = 'Em breve';
        }
        // } else if (productModule.releaseDays) {
        //   releaseLabel = `Disponível ${productModule.releaseDays} dias matrícula`;
      } else {
        releaseLabel = `Em breve`;
      }
    }
  }

  if (productModule.releaseDate) {
    const now = formatDate();

    if (formatDate(productModule.releaseDate).diff(now, 'seconds') > 0) {
      moduleUuid = null;

      if (productModule.showDate) {
        releaseLabel = `Disponível em: ${formatDate(productModule.releaseDate).format('DD/MM/YYYY [às] HH[h]mm')}`;
      } else {
        releaseLabel = 'Em breve';
      }
    }
  }

  return (
    <ModulesCardWrapper
      data-isrequired={true}
      data-isavailable={Boolean(moduleUuid)}
      to={createUrl('productModule', [productSlug, productClassUuid, moduleUuid])}
      type={moduleUuid ? 'internal' : 'nolink'}
      component={Flex}
    >
      <Flex flexDirection="column">
        <Flex px={{ m: 20 }} flexGrow={0} justifyContent="space-between">
          <Square />

          {Boolean(moduleUuid) && (
            <Box flexGrow={0} mt={{ m: 20 }}>
              <Typography type="type0" color="primary_contrast" upper mt={2}>
                {productModule.contentCount} conteúdos
              </Typography>
            </Box>
          )}
        </Flex>

        <Typography type="type5" color="primary_contrast" fontWeight="bold" mt={{ m: '10px' }} mx={{ m: 20 }}>
          {productModule.name}
        </Typography>
      </Flex>

      {Boolean(releaseLabel) && (
        <Typography
          type="type1"
          color="primary_contrast"
          opacity={0.6}
          ml={{ m: 20 }}
          mb={{ m: 20 }}
          dangerouslySetInnerHTML={createMarkup(releaseLabel)}
        />
      )}
    </ModulesCardWrapper>
  );
};
export default ModulesCard;
